declare global {
  interface Window {
    wisepops?: (action: string, ...args: unknown[]) => unknown;
  }
}

export const useWisepops = () => {
  const trigger = (eventName: string) => {
    window.wisepops?.("event", eventName);
  };

  return {
    trigger
  };
};
